import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import {Route, Switch} from 'react-router-dom';
import PropTypes from 'prop-types';

import {Container, Menu} from 'semantic-ui-react';

import {windowResize} from './actions/viewport';
import {sidebarToggle} from './actions/navigation';

import App from './apps';

import Page from './components/Page';
import Login from './containers/Login';
// import PrivateRoute from './containers/PrivateRoute';
import Notifications from './containers/Notifications';
import SettingsMenu from './containers/Settings';

import './Root.css';

class Root extends Component {

    componentDidMount() {
        // Add global events
        window.addEventListener('resize', this.props.windowResize);
    }
    componentWillUnmount() {
        // Remove global events
        window.removeEventListener('resize', this.props.windowResize);
    }

    shouldComponentUpdate({location, sidebar}) {
        return location !== this.props.location || sidebar !== this.props.sidebar;
    }

    render() {
        // console.log('Root render');
        const {history: {
                action
            }, location: {
                pathname
            }, sidebar} = this.props;
        return <div className="Root">
            <Menu className="Root-menu" fixed="top" size="large">
                <Menu.Item icon="sidebar" active={sidebar} onClick={this.props.sidebarToggle}/>
                <App.Menu/>
                <SettingsMenu/>
            </Menu>
            <div className="Root-sidebar">
                <App.Sidebar visible={sidebar}/>
            </div>
            <div className="Root-main">
                <Container as={Notifications} className="Root-notifications" text={true}/>
                <Container
                    as={Page}
                    className="Root-content"
                    direction={action === 'PUSH'
                        ? 'left'
                        : 'right'}
                    name={pathname}
                    text={true}>
                    <Switch>
                        <Route exact={true} path="/login" component={Login}/>
                        <Route path="/" component={App.Content}/>
                    </Switch>
                </Container>
            </div>
        </div>;
    }
}

Root.propTypes = {
    history: PropTypes
        .shape({action: PropTypes.string.isRequired})
        .isRequired,
    location: PropTypes
        .shape({pathname: PropTypes.string.isRequired})
        .isRequired,
    sidebar: PropTypes.bool.isRequired,
    sidebarToggle: PropTypes.func.isRequired,
    windowResize: PropTypes.func.isRequired
};

const connectedRoot = connect(({navigation: {
        sidebar
    }}) => ({sidebar}), {sidebarToggle, windowResize})(Root);
export default withRouter(connectedRoot);



// WEBPACK FOOTER //
// ./src/Root.js